import { DetailsTableDialog } from "../../../../../../shared/components/dialogs/details-table-dialog/details-table-dialog.view";
import { ComputePercent } from "../../../../../../shared/scripts/number-functions";
import { RenderDateMDY, RenderNullableNumberWithSeparators } from "../../../../../../shared/scripts/table-functions";
import { SiteMilestone } from "../../scripts/site-activation.entities";

var Highcharts = require('highcharts/highcharts');

export class MilestoneSummaryTab {

    dataTable: any;
    achievementChart: any;
    dataRows: MilestoneSummaryTableRow[];

    detailsTableModal: DetailsTableDialog;

    targetSites: number;

    //public static milestonesOfInterest: string[] = ["First Participant Randomized", "Activated for Enrollment", "Central IRB Approval Posted", "Central IRB Approval", "Central IRB Submission", "Site Training Complete", "Pre-screening Complete", "Site Study Addendum Executed", "Site Study Addendum Initiated", "Pre-Screening Agreement Executed", "Pre-screening Agreement Initiated", "Site Master Agreement Executed", "Site Master Agreement Initiated", "Site Selected", "Site Selection Visit", "Interest Letter/Form/Pack" ];
    public static milestonesOfInterest: string[] = ["First Participant Randomized", "Activated for Enrollment", "Central IRB Approval Posted", "Central IRB Approval", "Central IRB Submission", "Site Training Complete", "Site Study Addendum Executed", "Site Study Addendum Initiated", "Site Master Agreement Executed", "Site Master Agreement Initiated", "Site Selected", "Site Selection Visit", "Interest Letter/Form/Pack"];

    constructor() {
        this.initializeTable();
        this.initializeAchievementChart();

        this.setSelectedChartSeries("default");
        this.initializeButtons();
    }

    updateContent(milestonesTable: SiteMilestone[], milestonesChart: SiteMilestone[], primeContractsSelected: string[]): void {

        this.dataTable.clear();

        this.targetSites = 0;
        if (primeContractsSelected.includes("NEURO")) { this.targetSites += 25; }
        if (primeContractsSelected.includes("VITAL")) { this.targetSites += 60; }
        if (primeContractsSelected.includes("SLEEP")) { this.targetSites += 45; }
        if (primeContractsSelected.includes("AUTONOMIC")) { this.targetSites += 50; }
        if (primeContractsSelected.includes("ENERGIZE")) { this.targetSites += 60; }

        let overallMilestoneTable = milestonesTable.filter((milestone: SiteMilestone) => milestone.AppendixA == 1 && milestone.AppendixB == 1);
        let overallMilestoneChart = milestonesTable.filter((milestone: SiteMilestone) => milestone.AppendixA == 1 && milestone.AppendixB == 1);


        this.dataTable.rows.add(this.getTableContent(overallMilestoneTable)).draw();

        this.setChartContent(overallMilestoneChart);
    }

    private getTableContent(milestones: SiteMilestone[]): MilestoneSummaryTableRow[] {

        let rowHash: Map<string, MilestoneSummaryTableRow> = new Map<string, MilestoneSummaryTableRow>();

        let recoverCohortSites: string[] = [];
        let nonRecoverCohortSites: string[] = [];

        milestones.forEach((milestone: SiteMilestone) => {

            if (milestone.IsRecoverCohort == 0) {
                if (!nonRecoverCohortSites.includes(milestone.MilestoneSiteHash)) { nonRecoverCohortSites.push(milestone.MilestoneSiteHash); }
            }
            else if (milestone.IsRecoverCohort == 1) {
                if (!recoverCohortSites.includes(milestone.MilestoneSiteHash)) { recoverCohortSites.push(milestone.MilestoneSiteHash); }
            }

            if (milestone.CompletionDate == undefined || milestone.MilestoneId == 35) return; //only want milestones that are completed and not lastest randomized

            let row: MilestoneSummaryTableRow;
            if (rowHash.has(milestone.Milestone)) { row = rowHash.get(milestone.Milestone); }
            else { row = new MilestoneSummaryTableRow(); row.TargetSites = this.targetSites; row.MilestoneId = milestone.MilestoneId; row.Milestone = milestone.Milestone; row.OrderBy = milestone.OrderBy; }

            row.addValue(milestone);
            //if (milestone.IsRecoverCohort == 0) { row.NonRecoverCohortCount += 1; row.OverallCount += 1; row.addValue(milestone.SiteName, true); }
            //else if (milestone.IsRecoverCohort == 1) { row.RecoverCohortCount += 1; row.OverallCount += 1; row.addValue(milestone.SiteName, false); }

            rowHash.set(row.Milestone, row);
        });

        //$('#non-recover-site-count').html(nonRecoverCohortSites.length + "");
        //$('#recover-site-count').html(recoverCohortSites.length + "");
        //$('#milestone-table-overall-site-count').html((recoverCohortSites.length + nonRecoverCohortSites.length) + "");
        //$('#milestone-table-overall-site-count').html((recoverCohortSites.length + nonRecoverCohortSites.length) + "");
        $('#milestone-table-overall-site-count').html(this.targetSites + "");

        this.dataRows = Array.from(rowHash.values());
        this.dataRows.forEach((row: MilestoneSummaryTableRow) => {
            row.setDisplayValues(recoverCohortSites.length, nonRecoverCohortSites.length);
        });
        this.dataRows.sort((a: MilestoneSummaryTableRow, b: MilestoneSummaryTableRow) => a.OrderBy - b.OrderBy);
        return this.dataRows;
    }

    //not using filteredMilestones since this is historic
    private setChartContent(milestones: SiteMilestone[]) {

        //const start = new Date().getTime();

        //get unique dates
        let primeContractsSelected: string[] = [];
        let uniqueSites: string[] = [];
        let uniqueDates: number[] = [];
        milestones.forEach((milestone: SiteMilestone) => {
            if (!primeContractsSelected.includes(milestone.PrimeContract)) { primeContractsSelected.push(milestone.PrimeContract); }

            let timestamp: number = milestone?.CompletionDate?.getTime();
            if (timestamp != undefined && !uniqueDates.includes(timestamp)) {
                uniqueDates.push(timestamp);
            }
            if (!uniqueSites.includes(milestone.MilestoneSiteHash)) { uniqueSites.push(milestone.MilestoneSiteHash); }
        });
        uniqueDates.sort((a: number, b: number) => a - b);

        let chartData: MilestoneSummaryChartDataSeries[] = [];
        //let currentCounts: number[] = [ 0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0 ];
        let currentCounts: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        MilestoneSummaryTab.milestonesOfInterest.map((label: string, index: number) => {
            chartData.push(new MilestoneSummaryChartDataSeries(label, ""));
        });

        let milestone: SiteMilestone;
        uniqueDates.forEach((date: number) => {
            //currentCounts = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
            currentCounts = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            MilestoneSummaryTab.milestonesOfInterest.forEach((label: string, index: number) => {
                milestones.forEach((milestone: SiteMilestone) => {
                    if (milestone.Milestone == label) {
                        if (milestone.CompletionDate?.getTime() <= date) {
                            currentCounts[index] += 1;
                        }
                    }
                });
            });

            currentCounts.forEach((count: number, index: number) => {
                chartData[index].data.push([date, count]);
            });
        });

        //const duration = new Date().getTime() - start;

        //console.log(uniqueDates);
        //console.log(chartData);
        //console.log(`milestones chart = ${duration / 1000}s`);

        //console.log(this.achievementChart);

        chartData.forEach((data: MilestoneSummaryChartDataSeries, index: number) => {
            this.achievementChart.series[index].setData(data.data);
        });
        $('#milestones-summary-sites-count-label').html(uniqueSites.length + "");


        //only have targets for NEURO, VITAL, and SLEEP
        //let target: number = 0;
        //if (primeContractsSelected.includes("NEURO")) { target += 25; }
        //if (primeContractsSelected.includes("VITAL")) { target += 71; }
        //if (primeContractsSelected.includes("SLEEP")) { target += 50; }
        //if (primeContractsSelected.includes("AUTONOMIC")) { target += 50; }
        //if (primeContractsSelected.includes("ENERGIZE")) { target = 0; }
        
        if (this.targetSites > 0) {
            this.achievementChart.yAxis[0].update({
                plotLines: [{
                    value: this.targetSites,
                    dashStyle: 'longdash',
                    label: {
                        text: 'Target Site Activation (n = ' + this.targetSites + ')'
                    },
                    zIndex: 5
                }]
            });
        }
        else { 
            this.achievementChart.yAxis[0].update({
                plotLines: []
            });
        }

        let max: number = (this.targetSites > uniqueSites.length) ? this.targetSites : uniqueSites.length;
        this.achievementChart.yAxis[0].update({
            //max: (max + 2)
            max: max
        });

    }

    private initializeTable(): void {
        this.dataTable = $('#milestones-summary-table').DataTable({
            //"dom": '<"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            searching: false,
            scrollX: true,
            //scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            ordering: false,
            columns: [
                { data: "Milestone", title: "Milestone", className: "text-left font-size12 nowrap" },
                { data: { _: "NonRecoverCohortDisplay", sort: "NonRecoverCohortCount" }, title: "Not RECOVER Cohort", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: { _: "RecoverCohortDisplay", sort: "RecoverCohortCount" }, title: "RECOVER Cohort", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: { _: "OverallDisplay", sort: "OverallCount" }, title: "Overall<br>(Target N = <span id='milestone-table-overall-site-count'></span>)", className: "overall-data text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "OrderBy", visible: false },
            ],
            columnDefs: [
                { target: 0, orderable: false }
            ],
            order: [[4, 'asc']]
        });

        this.detailsTableModal = new DetailsTableDialog([
                { data: "PrimeContract", title: "Protocol", className: "prime-contract text-center font-size12 nowrap", width: '100px' },
                { data: { _: "SiteNumberDisplay", sort: "SiteNumber" }, title: "Site Id", className: "site-id text-center font-size12 nowrap", width: '100px' },
                { data: { _: "SiteNameDisplay", sort: "SiteName" }, title: "Site Name", className: "text-left font-size12" },
                { data: "DateCompletion", title: "Completion Date", className: "completion-date text-left font-size12 nowrap", render: RenderDateMDY },
            ], [[3, 'desc']]);
    }

    private initializeAchievementChart(): void {

        this.achievementChart = Highcharts.chart('milestones-summary-chart', {
            chart: {
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        align: 'right', // right by default
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 45
                    },
                    relativeTo: 'chart'
                }
            },
            tooltip: {
                //xDateFormat: '%m/%d/%Y',
                xDateFormat: '%d%b%Y',
                shared: true,
                split: false,
                enabled: true,
                formatter: function (tooltip) {
                    //to make points appear in order in tooltip
                    this.points.reverse();
                    return tooltip.defaultFormatter.call(this, tooltip);
                },
            },
            title: {
                text: ''
            },
            credits: { enabled: false },
            plotOptions: {
                line: {
                    marker: { enabled: false }
                }
            },
            yAxis: {
                title: { text: 'Site Count' }
            },
            xAxis: {
                type: 'datetime',
                crosshair: {
                    snap: true
                },
                labels: {
                    formatter: function () {
                        //return Highcharts.dateFormat('%m/%d/%y', this.value);
                        return Highcharts.dateFormat('%d%b%y', this.value);
                    }
                },
                events: {
                    afterSetExtremes: function (event) {
                        if (event.max < event.dataMax || event.min > event.dataMin) {
                            $("#milestones-summary-chart-resetZoom").show();

                        }
                        else {
                            $("#milestones-summary-chart-resetZoom").hide();
                        }
                    }
                }
            },
            legend: {
                enabled: true,
                reversed: true,
                margin: 30,
                align: 'right',
                verticalAlign: 'top',
                layout: 'vertical'
            }
        });

        let seriesColors: string[] = ['#0093af', '#f2ba49', '#3e864e', '#3e864e', '#3e864e', '#5b9bd5', '#673284', '#673284', '#de4846', '#de4846', '#4c4c4c', '#4c4c4c', '#888ea2']
        let seriesLineStyle: string[] = ['solid', 'solid', 'solid', 'dash', 'dot', 'solid', 'solid', 'dot', 'solid', 'dot', 'solid', 'dot', 'solid', 'solid'];
        for (let i = 0; i < MilestoneSummaryTab.milestonesOfInterest.length; ++i) {
            this.achievementChart.addSeries({
                name: MilestoneSummaryTab.milestonesOfInterest[i],
                data: [],
                color: seriesColors[i],
                dashStyle: seriesLineStyle[i]
            });
        }
    }

    private initializeButtons(): void {
        $("#milestones-summary-chart-resetZoom").hide();

        $("#milestones-summary-chart-resetZoom").click(() => {
            this.achievementChart.zoomOut();
        })
    }

    setSelectedChartSeries(type: string): void {
        let indices: number[] = [];

        if (type == 'default') { indices = [ 0, 1, 2, 4, 6, 8, 10, 12 ]; }

        for (let i: number = 0; i < this.achievementChart.series.length; ++i) {
            if (indices.includes(i)) { this.achievementChart.series[i].show(); }
            else { this.achievementChart.series[i].hide(); }
        }
    }

    showDetailTableModal(id: any, type: string): void {

        for (let i = 0; i < this.dataRows.length; ++i) {
            if (this.dataRows[i].MilestoneId == id) {
                let data: any[] = this.dataRows[i].getSelectedData(type);
                this.detailsTableModal.setData(data);
                this.detailsTableModal.show(this.dataRows[i].Milestone + " (n = " + data.length + ")");
                break;
            }
        }
    }

}

export class MilestoneSummaryTableRow {
    MilestoneId: number;
    Milestone: string;
    RecoverCohortCount: number = 0;
    RecoverCohortDisplay: string = "";
    NonRecoverCohortCount: number = 0;
    NonRecoverCohortDisplay: string = "";
    OverallCount: number = 0;
    OverallDisplay: string = "";
    OrderBy: number = -1;
    Milestones: SiteMilestone[][];
    TargetSites: number;

    constructor() { this.Milestones = [[], []]; }

    addValue(siteMilestone: SiteMilestone): void {
        this.OverallCount++;

        if (siteMilestone.IsRecoverCohort == 1) {
            this.RecoverCohortCount++;
            this.Milestones[1].push(siteMilestone);
        }
        else
        {
            this.NonRecoverCohortCount++;
            this.Milestones[0].push(siteMilestone);
        }
    }

    setDisplayValues(recoverCount: number, nonRecoverCount: number): void {
        //this.RecoverCohortDisplay = this.getDisplayValue(this.RecoverCohortCount, recoverCount, "recover");
        //this.NonRecoverCohortDisplay = this.getDisplayValue(this.NonRecoverCohortCount, nonRecoverCount, "nonrecover");
        //this.OverallDisplay = this.getDisplayValue(this.OverallCount, (recoverCount + nonRecoverCount), "overall");
        this.RecoverCohortDisplay = this.getDisplayValue(this.RecoverCohortCount, 0, "recover");
        this.NonRecoverCohortDisplay = this.getDisplayValue(this.NonRecoverCohortCount, 0, "nonrecover");
        this.OverallDisplay = this.getDisplayValue(this.OverallCount, 0, "overall");
    }

    private getDisplayValue(count: number, total: number, type: string): string {
        let percent: number = ComputePercent(count, this.TargetSites);
        let display: string = "<span class='underline-hover font-underline' onclick='page.showDetailTableModal(\"" + this.MilestoneId + "\", \"" + type + "\")'>";
        if (type == "overall") { display += count + " (" + Math.round(percent) + "%)</span>"; }
        else { display += count + ""; }
        return display;
    }

    getSelectedData(type: string): any[] {
        if (type == "recover") return this.Milestones[1];
        else if (type == "nonrecover") return this.Milestones[0];
        else if (type == "overall") return [...this.Milestones[0], ...this.Milestones[1]];
    }
}

export class MilestoneSummaryChartDataSeries {
    name: string;
    color: string;
    data: any[]; //Date.getTime(), count

    constructor(name: string, color: string) {
        this.name = name;
        this.color = color;
        this.data = [];
    }
}